export default __webpack_public_path__ + "static/media/Coca-Cola.d12cdc26.png";